import { Divider } from "@mui/material";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "context";
import { analytics } from "layouts/dashboards/analytics/analytics";
import { events } from "layouts/dashboards/analytics/events";

export function ArcadeEmbed() {
  const { getCurrentUser } = useContext(AuthContext);
  
  useEffect(() => {
    const start_time = Date.now();
    const getUserId = async () => {
      const user = await getCurrentUser();
      return user;
    };
    getUserId().then((user) => {
      analytics.track(events.VIEW_PAGE, { page: "home-page", userId: user });
    });
    return () => {
      getUserId().then((user) => {
        analytics.track(events.PAGE_LEFT, { page: "home-page", userId: user, start_time: start_time, end_time: Date.now() });
      });
    }
  }, []);

  return (
    <div
      style={{
        position: "relative",
        paddingBottom: "calc(49.21875% + 41px)",
        height: 0,
        width: "100%",
        marginBottom: "-100px",
      }}
    >
      <iframe
        src="https://demo.arcade.software/nhOur9AxzX7BI58dEmeU?embed&embed_mobile=inline&embed_desktop=inline&show_copy_link=true"
        title="QuIP - QuSkillBridge"
        frameBorder="0"
        loading="lazy"
        allowFullScreen
        allow="clipboard-write"
        style={{
          position: "absolute",
          top: 0,
          left: "10%",
          width: "80%",
          height: "80%",
          colorScheme: "light",
        }}
      />
    </div>
  );
}

const HomePage = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDTypography variant="h3" mt={2}>
        Welcome to QuSkillBridge!
      </MDTypography>
      <MDTypography variant="body2" mt={2}>
        Learn how to use the QuSkillBridge application below or head to the{" "}
        <Link
          to="/course-catalog"
          style={{ color: "blue", fontWeight: "bold", cursor: "" }}
        >
          Course Catalog
        </Link>{" "}
        to start your QuSkillBridge journey.
      </MDTypography>
      <Divider />
      <ArcadeEmbed />
    </DashboardLayout>
  );
};

export default HomePage;
